import { useEffect, useState } from 'react'
import { GENDER_LIST_ONBOARDING } from 'src/consumer/constants'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { getDateOfPrescription } from '../../../PrescriptionMakingPageComponents'
import { PMPHeaderDetails } from '../../../PrescriptionMakingPageStyles'
import PrescriptionKVItem from '../../common/PrescriptionKVItem'

export default function DefaultPatientDetails({
  prescriptionData,
  prescriptionViewSettings,
  leaveSpace,
  hideQRCode = false,
  debug,
  customizations = {},
}) {
  return (
    <>
      <PMPHeaderDetails
        noColor={true}
        debug={debug}
        style={{
          borderTop: '1px solid black',
        }}
        className="d-flex align-items-center justify-content-between"
      >
        <div>
          <PrescriptionKVItem
            itemKey="Patient"
            topContainerProps={{ style: customizations.patientNameKeyStyle }}
            valueItemProps={{
              style: {
                textTransform: 'capitalize',
                ...customizations.patientNameValStyle,
              },
            }}
            value={
              <>
                {prescriptionData?.patientPrefill?.name}{' '}
                {prescriptionData?.patientPrefill?.patientNumber &&
                  `(${prescriptionData?.patientPrefill?.patientNumber})`}
              </>
            }
          />
          <br />
          <PrescriptionKVItem
            itemKey="Age/Sex"
            value={
              <>
                {getAgeFromDobWithTime(prescriptionData?.patientPrefill?.vital?.dateOfBirth)}/
                {
                  GENDER_LIST_ONBOARDING?.find(
                    (item) => item.value === prescriptionData?.patientPrefill?.vital?.gender,
                  )?.label
                }
              </>
            }
          />
          <br />
          <PrescriptionKVItem
            itemKey="Date"
            value={<>{getDateOfPrescription(prescriptionData, false)}</>}
          />
          {customizations.showMobile && prescriptionData?.patientPrefill?.mobile && (
            <>
              <br />
              <PrescriptionKVItem
                itemKey="Mobile"
                topContainerProps={{ style: customizations.patientMobileKeyStyle }}
                valueItemProps={{ style: customizations.patientMobileValStyle }}
                value={<>{prescriptionData?.patientPrefill?.mobile}</>}
              />
            </>
          )}
          {customizations.showAddress && prescriptionData?.patientPrefill?.location?.city && (
            <>
              <br />
              <PrescriptionKVItem
                itemKey="City"
                topContainerProps={{ style: customizations.patientAddressKeyStyle }}
                valueItemProps={{ style: customizations.patientAddressValStyle }}
                value={<>{prescriptionData?.patientPrefill?.location?.city}</>}
              />
            </>
          )}
          {customizations.showEmail && prescriptionData?.patientPrefill?.email && (
            <>
              <br />
              <PrescriptionKVItem
                itemKey="Email"
                topContainerProps={{ style: customizations.patientEmailKeyStyle }}
                valueItemProps={{ style: customizations.patientEmailValStyle }}
                value={<>{prescriptionData?.patientPrefill?.email}</>}
              />
            </>
          )}
        </div>
        {prescriptionData?.prescriptionData?.qrCodeImageId && !hideQRCode && (
          <QRCodeImage imageId={prescriptionData.prescriptionData.qrCodeImageId} />
        )}
      </PMPHeaderDetails>
    </>
  )
}

export const QRCodeImage = ({ imageId }) => {
  const [imageUrl, setImageUrl] = useState(null)
  const [prevImageId, setPrevImageId] = useState(null)
  const [loading, setLoading] = useState(true)
  const maxRetries = 3
  const interval = 1400 // 1 second

  const fetchImageWithPolling = async (id) => {
    const url = getImageLink(id)
    let attempts = 0
    await new Promise((resolve) => setTimeout(resolve, interval))
    while (attempts < maxRetries) {
      try {
        const response = await fetch(url, { mode: 'cors' })

        if (response.ok) {
          const imageBlob = await response.blob()
          const imageObjectURL = URL.createObjectURL(imageBlob)
          setImageUrl(imageObjectURL)
          setLoading(false)
          return
        } else {
          console.log({ response })
          console.info(`Attempt ${attempts + 1}: Image not available (Status: ${response.status})`)
        }
      } catch (error) {
        console.log({ error })
        console.error(`Attempt ${attempts + 1}: Error fetching image - ${error.message}`)
      }

      attempts++
    }

    setLoading(false)
    console.error('Image not available after maximum retries')
  }

  useEffect(() => {
    if (imageId) {
      setPrevImageId((prev) => {
        if (prev !== imageId) {
          fetchImageWithPolling(imageId)
          return imageId
        }
        return prev
      })
    }
  }, [imageId])

  return (
    <>
      {loading ? (
        <div>Loading...</div>
      ) : (
        imageUrl && (
          <div className="d-flex flex-column align-items-center">
            <img src={imageUrl} alt="prescription-qr" height="60px" width="60px" crossOrigin="anonymous" />
            <span style={{ textAlign: 'center' }}>View Online</span>
          </div>
        )
      )}
    </>
  )
}
